export default __webpack_public_path__ + "static/media/portfolio-arianjs.a9ef7ec9.jpeg";